module.exports = __webpack_public_path__ + "static/img/licesence-01_rotated.db57a18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/licesence-01_rotated.jpg
// module id = B6KG
// module chunks = 1